<script setup>
defineProps({
  width: {
    type: Number,
    default: 24,
  },
  height: {
    type: Number,
    default: 24,
  },
});
</script>

<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.2246 4C15.2566 4 13.7183 5.48698 12.3257 7.37589C10.4121 4.93144 8.81164 4 6.89643 4C2.99175 4 0 9.09793 0 14.4938C0 17.8703 1.62829 20 4.35564 20C6.31861 20 7.73038 19.0716 10.2401 14.6703C10.2401 14.6703 11.2863 12.8169 12.0061 11.5401C12.2583 11.9486 12.5239 12.3888 12.8029 12.8607L13.9798 14.8469C16.2724 18.6957 17.5498 20 19.8643 20C22.5213 20 24 17.8412 24 14.3945C24 8.74483 20.9408 4 17.2246 4ZM8.32631 13.4786C6.29148 16.6786 5.58754 17.3959 4.45463 17.3959C3.28873 17.3959 2.59578 16.369 2.59578 14.5379C2.59578 10.6207 4.54262 6.61517 6.86343 6.61517C8.12021 6.61517 9.17047 7.34333 10.7792 9.65378C9.25164 12.0044 8.32631 13.4786 8.32631 13.4786ZM16.006 13.0758L14.5989 10.7214C14.2181 10.1001 13.8521 9.5282 13.501 9.00572C14.7693 7.04196 15.8154 6.06345 17.0596 6.06345C19.6444 6.06345 21.7122 9.88138 21.7122 14.571C21.7122 16.3586 21.1286 17.3959 19.9193 17.3959C18.7603 17.3959 18.2067 16.628 16.006 13.0758Z"
      fill="#8C8C8C"
    />
  </svg>
</template>
